import React, { useState, useContext } from 'react';
import { Row, Col } from 'react-bootstrap'

function HelpTile(props) {
  return (
    <>
      <Row>
        <Col style={{ marginTop: 40, textAlign: 'center' }}>
          <a href="https://support.owllabs.com/hc/en-us">Need Help?</a> or <a href="mailto:wfhscheduler@owllabs.com">Have Feedback?</a>
        </Col>
      </Row>
      <Row>
        <Col style={{ textAlign: 'center' }}>
          <a href="https://www.wfhscheduler.com/privacy-policy">Privacy Policy</a>
        </Col>
      </Row>
    </>
  )
}

export default HelpTile;